import React, { useEffect, useRef, useState } from 'react'
import qs from 'qs'
import classNames from 'classnames'
import { message as mes, request } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'
import { Card, BatchAll, BatchNum, BatchOptions, BatchStop, BatchStart, ClearFilter } from 'component'
import { Icon } from 'meinian-package/src/component'
import { BaseFilter } from 'component/filter'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { convertParams, generateParamsLength, deleteEmptyKey } from 'component/util'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../../components/header/customizeHeader'
import './index.less'

export default function Index() {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const defaultParams = {
    qualityFlag: 0,
    duplicateFilter: 0,
    subscribeType: 0,
  }

  const [navs, setNavs] = useState([])
  const [navValue, setNavValue] = useState([])
  const [params, setParams] = useState(query.params || {})
  const [isBatch, setIsBatch] = useState(false)
  const [batchAll, setBatchAll] = useState([])
  const $masonry = useRef()

  useEffect(() => {
    fetchNavs()
    if (query.rootClassifyName && query.classifyName && query.rootClassifyName != query.classifyName) {
      setNavValue([query.classifyName])
    }
    convertTime()
    const sub = () => { fetchNavs(); $masonry.current?.init() }
    mes.sub('onMNUploadImage', sub)
    mes.sub('removeInsImage', sub)
    return () => { mes.remove('onMNUploadImage', sub) }
  }, [])

  const fetchNavs = async () => {
    try {
      const res = await request.post('/zhikuan/intellect-classify/list-detail', {
        ...query.params,
        name: query.rootClassifyName?.replace(/采集|上新/ig, ''),
        type: Number(query.type)
      })
      const _navs = convert(res)
      setNavs(_navs)
    } catch (error) {
      console.error(error)
    }
  }
  const convertTime = () => {
    if (query.type == 36 || query.type == 37) {
      return query.rootClassifyName.substring(0, 4)
    }
  }

  const labelMatrix = () => {
    if (query.type === '36' || query.type === '37') {
      return convertParams(params).labelMatrix
    }
    return [...(convertParams(params).labelMatrix || []), navValue.length ? navValue : getValues(navs).filter((_, index) => index !== 0)]
  }

  return <>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '智能分类',
          path: '/home/category-tags'
        },
        {
          name: convertTime() || query.rootClassifyName,
          path: null
        }
        ]}
      />}
    />
    <div className="meinian-detail-intelligent">
      <div className="breadcrumb-wrap" style={{ height: 64, marginBottom: 8 }}>
        {convertTime() || query.rootClassifyName}
      </div>
      {navs.length ? <Nav data={navs} value={navValue} onChange={setNavValue} /> : null}
      <div className="screen-wrap">
        {isBatch ? <div>
          <div className="meinian-space" />
          <BatchAll style={{ marginRight: 16 }} keyValues={batchAll.map(m => `${m.imageGroupEntityId},${m.inspirationId}`)} infos={batchAll} />
          <BatchNum style={{ marginRight: 40 }} />
          <BatchOptions.Collect data={batchAll} onChange={() => { setIsBatch(false); $masonry.current?.init() }} />
          <BatchOptions.Download fileName="智能分类" onChange={() => { setIsBatch(false) }} />
          <BatchOptions.Export
            fileName="智能分类"
            onChange={() => {
              util.track('mn-statement-export', {
                module1: '批量导出',
                module2: '分类标签',
              })
              setIsBatch(false)
            }}
          />
          <BatchStop onClick={() => setIsBatch(false)} />
        </div> : <div>
          <BaseFilter
            value={params}
            onChange={setParams}
            filterProps={{
              useGenderAndCategory: false,
              hiddenGender: true,
              hiddenCategory: query.type === '1',
              hiddenPlatform: query.type === '0' && query.params?.platformId,
              hiddenDate: query.type === '36' || query.type === '37',
              hiddenElement: !['1', '0', '36', '37'].includes(query.type),
              hiddenColl: true,
              hiddenUser: true,
            }}
          />
          <div className="meinian-space" />
          {generateParamsLength(params, deleteEmptyKey(query.params)) ? <ClearFilter onChange={() => setParams(query.params || {})} /> : null}
          <BatchStart onClick={() => setIsBatch(true)} />
        </div>}
      </div>
      <div style={{ padding: '0 4px 0 24px' }}>
        <MNWaterfallApi
          idKey={['imageGroupEntityId', 'inspirationId']}
          renderItem={Card.Image}
          cardProps={{ isBatch, showMoveImage: true, allStyleFlag: true, trackSourceType: '分类标签', }} // allStyleFlag 区别于灵感集的硬编码
          url="/zhikuan/image-bus/inspiration/list-blog"
          method="spost"
          params={{
            ...defaultParams,
            ...convertParams(params),
            blogTimeList: query.type === '37' ? (navValue.length ? navValue : getValues(navs).filter((_, index) => index !== 0)) : null,
            timeList: query.type === '36' ? (navValue.length ? navValue : getValues(navs).filter((_, index) => index !== 0)) : null,
            labelMatrix: labelMatrix()
          }}
          ref={$masonry}
          afterLoad={data => setBatchAll(data)}
        />
      </div>
    </div>
  </>
}
function convert(result) {
  const all = []
  result.classifyBaseDTOList.forEach((m) => {
    const item = { label: m.classifyName, value: m.classifyName, color: m.color, num: m.totalNumber }
    all.push(item)
  })
  all.unshift({ label: result.name, value: result.name, num: result.num, isRoot: true })
  return all
}
function getValues(navs) {
  if (!navs.filter(m => m.children).length) {
    return navs.map(m => m.value)
  }
  const all = []
  navs.forEach((m) => {
    all.push(...m.children.map(n => n.value))
  })
  return all
}
const Nav = (props) => {
  const { data = [], value = [], onChange } = props
  const [overflow, setOverflow] = useState(true)
  const [isFold, setIsFold] = useState(true)
  const $nav = useRef()
  useEffect(() => {
    if ($nav.current.scrollHeight <= $nav.current.clientHeight + 16) {
      setOverflow(false)
      setIsFold(false)
    }
  }, [])

  const onClickItem = (item) => {
    onChange && onChange(item.value ? [item.value] : [])
  }
  return <div className="nav">
    <div className="root-wrap" ref={$nav} style={{ height: isFold ? 40 : '', overflow: 'hidden' }}>
      {data.map((item, index) => <div
        className={classNames('root-item', {
          active: (value.includes(item.value) && !item.isRoot) || (value.length < 1 && item.isRoot)
        })}
        onClick={() => (index === 0 ? onClickItem('') : onClickItem(item))}
      >
        <span className="root-item-label">{item.label}</span>
        <span className="root-item-num">{item.num}</span>
      </div>)}
    </div>
    {overflow ? <div className="fold-btn" onClick={() => setIsFold(!isFold)}>
      <span style={{ marginRight: 3 }}>{isFold ? '展开' : '收起'}</span><Icon type={isFold ? 'm-Vxing_xia' : 'm-Vxing_shang'} />
    </div> : null}
  </div>
}
